import storeApi from "@/services/api/Store";
import { StoreAdditionDTO } from "@/services/api/Store/dtos";
import { IStore } from "@/services/api/Store/types";
import { uploadOriginalAndPreviewImagesToFirebase } from "@/utils/firebase/functions";
import { getStoreImagesFirebasePath } from "@/utils/stringUtils";

export const STORE_OPERATION_STEPS = [
  "Dados gerais",
  "Localização",
  "Imagens",
  "Horários de funcionamento",
];

export const handleCreateStore = async (storeAdditionDto: StoreAdditionDTO) => {
  const newStore: IStore = {
    name: storeAdditionDto.name,
    email: storeAdditionDto.email,
    CNPJ: storeAdditionDto.CNPJ,
    phone: storeAdditionDto.phone,
    description: storeAdditionDto.description,
    logradouro: storeAdditionDto.logradouro,
    number: storeAdditionDto.number,
    district: storeAdditionDto.district,
    city: storeAdditionDto.city,
    state: storeAdditionDto.state,
    CEP: storeAdditionDto.CEP,
    country: "Brazil",
    lat: storeAdditionDto.lat,
    lng: storeAdditionDto.lng,
    imageOriginal: [],
    imagePreview: [],
    listTags: "",
    timeMonday: storeAdditionDto.timeMonday,
    timeTuesday: storeAdditionDto.timeTuesday,
    timeWednesday: storeAdditionDto.timeWednesday,
    timeThursday: storeAdditionDto.timeThursday,
    timeFriday: storeAdditionDto.timeFriday,
    timeSaturday: storeAdditionDto.timeSaturday,
    timeSunday: storeAdditionDto.timeSunday,
  };

  const createdStoreResponse = await storeApi.createStore(newStore);

  if (storeAdditionDto.images.length > 0) {
    const { originalImageUrls, previewImageUrls } =
      await uploadOriginalAndPreviewImagesToFirebase(
        storeAdditionDto.images,
        getStoreImagesFirebasePath(
          createdStoreResponse?.name,
          createdStoreResponse?.id
        )
      );
    newStore.imageOriginal = originalImageUrls;
    newStore.imagePreview = previewImageUrls;

    const updatedStoreResponse = await storeApi.updateStore(
      createdStoreResponse.id,
      newStore
    );

    return updatedStoreResponse;
  }

  return createdStoreResponse;
};
